
import { Options, Vue } from 'vue-class-component';
import HelloWorld from '../../components/HelloWorld.vue';
import {privacyConfig} from '@/config/template';
import {DataUtil} from '@/util/DataUtil';

@Options({
  components: {
    HelloWorld,
  }
})
export default class App extends Vue {


    private temp: string = privacyConfig.template_0516;

    private config: TemplateInterface = {
      productName: '阳光餐厅',
      companyFullName: '海南云兆网络技术有限公司',
      companyShortName: '海南云兆',
      officialWebsite: 'http://www.hainanyunzhao.com',
      sdkWebsite: 'https://privacyh5.coohua.com/thirdpart.html'
    };



    mounted(){
      this.temp = DataUtil.replaceConfig(this.temp, this.config);
    }
}
